var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-inline-flex"},[_c('router-link',{staticClass:"pill event-category-pill tw-text-white tw-flex tw-items-center cursor-pointer hover:tw-opacity-75",style:({ backgroundColor: _vm.category.color }),attrs:{"to":_vm.handleRouteTo}},[_vm._v(" "+_vm._s(_vm.category.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }